<template>
    
      <b-card>
        <b-row>
          <div style="position:absolute; top:10px; right:25px;">
            <span style="display:inline-block" class="mr-2">
              <b-form-select v-model="salesPersonMetricsFilters.salesRep" @change="onGetSalesPersonMetrics" class="mb-2">
                <option :value="null"> -- All Sales Rep -- </option>
                <option v-for="(rep, i) in salesReps" :key="i" :value="rep.id">{{rep.name}} </option>
              </b-form-select>
            </span>
            <span style="display:inline-block">
              <b-form-select :value="salesPersonMetricsSelectedDateRange" @change="onDateRangeChange" class="mb-2 mr-2">
                <option v-for="(type) in dateRangeTypes" :key="type" :value="type">  
                  {{type}}
                </option>
              </b-form-select> 
            </span>
          </div>
          <b-modal size="sm" title="Custom Date for Sales Person Metrics" id="custom-date-sales-person-metrics" @ok="onCustomSet" no-close-on-backdrop>
            <div style="display:flex; flex-direction: row; justify-content: center; top: 0;">
              <!-- v-if="salesPersonMetricsSelectedDateRange === dateRangeTypes.CUSTOM" -->
            <b-form-group label="From"  class="mb-4 mr-2" >
              <date-picker v-model="salesPersonMetricsFilters.dateFrom" :config="datePickerOptions" size="sm" />
            </b-form-group>
            <b-form-group label="To" class="mb-4">
              <date-picker v-model="salesPersonMetricsFilters.dateTo" :config="datePickerOptions" size="sm" />
            </b-form-group>
            </div>          
          </b-modal>    
        </b-row>
        <br/>
        <div>
          <apex-chart chartType="bar" :chartOptions="chartOptions" :chartSeries="chartSeries" />
        </div>
      </b-card>  
</template>

<script>
  import ApexChart from './../extensions/ApexChart'
  import { ACTIVE, REQUEST_DATE, DATE_FORMAT, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
  import { getDatesFromRangeString, dateToDay, generateListofDates } from '@/shared/helpers';
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

  export default {
    components: {
      ApexChart
    },
    data () {
      return {
        dateRangeTypes: REQUEST_DATE,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
        componentKey: 0,
        isLoadingWidget: true,
        salesBySalesRep: [],
        chartOptions: {},
        chartSeries: [],
      }
    },
    computed: {
      ...mapGetters('account', ['userId']),
      ...mapGetters('dashboard', ['salesPersonMetricsSelectedDateRange', 'salesPersonMetricsFilters']),
      ...mapState('salesReps', ['salesReps'])
    }, 
    methods: {
      ...mapActions('dashboard', ['getSalesPersonMetrics']),
      ...mapMutations('dashboard', ['setItem']),
      onDateRangeChange(value) { 
        if (value === REQUEST_DATE.CUSTOM) {
          this.salesPersonMetricsFilters.dateFrom = null;
          this.salesPersonMetricsFilters.dateTo= null;
          this.$bvModal.show('custom-date-sales-person-metrics');
        } else {
          const { dateFrom, dateTo } = getDatesFromRangeString(value);
          this.setDefaults(dateFrom, dateTo);
          this.salesPersonMetricsFilters.dateFrom = dateFrom;
          this.salesPersonMetricsFilters.dateTo= dateTo;
          this.onGetSalesPersonMetrics();
        }

        this.setItem({ resource: 'salesPersonMetricsSelectedDateRange', payload: value });
      },
      onCustomSet() {
        if (this.salesPersonMetricsFilters.dateFrom && this.salesPersonMetricsFilters.dateTo) {
          this.setDefaults(this.salesPersonMetricsFilters.dateFrom, this.salesPersonMetricsFilters.dateTo);
          this.onGetSalesPersonMetrics();
          
        }
        this.$bvModal.hide('custom-date-sales-person-metrics');
      },
      async onGetSalesPersonMetrics() {
        this.isLoadingWidget = true;

        await this.getSalesPersonMetrics(this.salesPersonMetricsFilters).then((res) => { 
          this.chartOptions = {
              ...this.chartOptions,
            noData: {
                text: (res.length > 0) ? '' : 'No available data'
            },
            xaxis: {  
                categories:  res.map(x => (x.salesPersonFullName == null) ? 'Unassigned' : x.salesPersonFullName)
            }
          }
          this.chartSeries = [
            {
                name: 'Requirements',
                data: res.map(x => x.reqCounts)
            },
            {
                name: 'Quotes',
                data: res.map(x => x.quotCounts)
            },
            {
                name: 'SO',
                data: res.map(x => x.soCounts)
            }
          ]
          this.isLoadingWidget = false;
        });
      },
      setDefaults(from = null, to = null) {
          this.chartOptions = { 
            chart: {
                id: 'sales-person-metrics-bar',
                type: 'bar',
            },
            title: {
                // text: (from && to) ?  'Sales Person Metrics' for ' + from + ' to ' + to : 'Sales Person Metrics'
                text: 'Sales Person Metrics'
            },
            plotOptions: {
                bar: {
                    horizontal: false
                }
            },
            noData: {
                text: 'Fetching data...'
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              show: true,
              width: 1,
              colors: ['#fff']
            }
          };
          this.chartSeries = [];
      }
    },
    mounted () {
      const { dateFrom, dateTo } = getDatesFromRangeString(this.salesPersonMetricsSelectedDateRange);
      this.setDefaults(dateFrom, dateTo);
      this.salesPersonMetricsFilters.dateFrom = dateFrom;
      this.salesPersonMetricsFilters.dateTo= dateTo;
      this.onGetSalesPersonMetrics();   
    },
  }
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>